// arranges the product cards and allows adding a new product card
import React, { useState, useEffect } from "react";
import { Row } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { DndContext, useSensors, useSensor, PointerSensor, closestCenter } from '@dnd-kit/core';
import { SortableContext, arrayMove } from '@dnd-kit/sortable';

import ProductCard from "./ProductCard";
import { setProducts } from "../../../utilities/redux/slices/currentEstimate";

const ProductDisplay = () => {
  const sensors = useSensors(
    useSensor(PointerSensor)
  );
  const dispatch = useDispatch();

  const [productCount, setProductCount] = useState(0);
  const [editModes, setEditModes] = useState([]);

  const currentProducts = useSelector((state) => state.currentEstimate.products);
  const estimate = useSelector((state) => state.currentEstimate);

  useEffect(() => {
    setProductCount(currentProducts.length);
    setEditModes([]);
    setEditModes(Array(currentProducts.length).fill(false));
  }, [currentProducts]);

  const handleDragEnd = (event) => {
    const {active, over} = event;

    if (active.id !== over.id) {
      const oldIndex = currentProducts.findIndex((product) => product.id === active.id);
      const newIndex = currentProducts.findIndex((product) => product.id === over.id);

      const newProducts = arrayMove(currentProducts, oldIndex, newIndex);

      dispatch(setProducts(newProducts));
    }
  };

  return (
    <div
      style={{
        padding: "10px",
        position: "relative",
        width: "100%",
      }}
    >
      <Row gutter={[16, 16]} style={{ height: "100%" }}>
        {/* <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={currentProducts.map((product) => product.id)}
          > */}
            {Array.from({ length: productCount }).map((_, i) =>
              <ProductCard
                productCount={productCount}
                setProductCount={setProductCount}
                setEditModes={setEditModes}
                product={currentProducts[i]}
                key={i}
              />
            )}
          {/* </SortableContext>
        </DndContext> */}

        {(productCount < 2) && (!estimate.finalized) && (
          <ProductCard
            productCount={productCount}
            setProductCount={setProductCount}
            setEditModes={setEditModes}
            add={true}
          />
        )}
      </Row>
    </div>
  );
};

export default ProductDisplay;
